import React from "react";

import { Checkbox } from "../../checkbox";
import { Props } from "./types";
import styles from "./styles.scss";

function Group({ group, isSelected, select, unSelect }: Props) {
  return (
    <div className={styles.group} onClick={!isSelected ? select : unSelect}>
      <Checkbox isChecked={isSelected} />
      <p className={styles.name}>{group.name}</p>
    </div>
  );
}

export { Group };
